// extracted by mini-css-extract-plugin
export default {"root":"ValueSaveOptionsDialog_root__6H7+z","placeHolderShimmer":"ValueSaveOptionsDialog_placeHolderShimmer__QOlvg"};